<template>
  <v-container no-gutters class="ma-0 px-0 pr-9" :style="`min-width:100vw; min-height:100vh; background-position:top center; background-size:initial; background-repeat: repeat; background-image:url('${require('../../assets/dark parchment background.jpg')};`">
    <v-card style="background-color:rgb(0,0,0,0); width:100%; margin-top:24px;margin-bottom:24px" elevation="0">
        <v-row>
            <v-col cols="4">
                <v-text-field
                    v-model="searchManeuver"
                    label="Enter Maneuver Name to Learn"
                    outlined
                    dense
                    :style="`background-color:antiquewhite`"
                    hide-details
                    @keyup.enter="addManeuver"
                ></v-text-field>
            </v-col>
            <v-col cols="3">
                <v-btn
                    @click="addManeuver"
                    :style="`background-color:antiquewhite`"
                >
                    Add Maneuver
                </v-btn>

                <v-menu offset-y nudge-left="60">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="color:black; margin-left:16px"
                        >
                        <v-icon style="font-size:32px;">settings</v-icon>
                        </v-btn>
                    </template>
                    
                    <v-list>
                        <!-- <v-list-item @click="savingSettingsDialog = true">
                            <v-list-item-title>Save/Load Settings</v-list-item-title>
                        </v-list-item> -->
                        <v-list-item @click="rulesDialog = true">
                            <v-list-item-title>Maneuver Rules</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="disciplineHelpDoc = true">
                            <v-list-item-title>Discipline Rules</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="websiteRulesDoc = true">
                            <v-list-item-title>Website Guide</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

            </v-col>
        </v-row>
    </v-card>
                                                                        <!-- Known -->
    <v-col>
    <h2>Known</h2>
    <v-row style="margin-top:4px" :style="`background-image:url('${require('../../assets/big_bar_bg.png')};background-position:center center; background-size:105% 100%;`">
        <v-col v-for="n in 9" :key="n" style="border-width:3px; border-style:ridge; background-color:transparent; border-color:grey;">
            <h2 align="center" style="color:antiquewhite">Level {{ n }}</h2>
            <v-list style="background-color:transparent">
                <draggable 
                    :animation="200"
                    :list="maneuverData.knownManeuvers[n]"
                    :group="{ 
                        name: 'all', 
                        pull: 'clone', 
                        put: false 
                    }"
                    item-key="id"
                    @start="(e)=>tempGrab(e,n)"
                    @end="ended"
                >
                    <v-list-item 
                        outlined 
                        v-for="element in maneuverData.knownManeuvers[n]" 
                        v-bind:key="element.name" 
                        @click="handleManeuverClick($event, element, maneuverData.knownManeuvers[n], 'known')"     
                        :style="`
                            width: 100%; 
                            border-color:${borderColor(element)};
                            border-width: ${element.basic ? '4px' : '2.5px'};
                            border-style: ${element.basic ? 'outset' : 'ridge'};
                            justify-content: center; 
                            margin-bottom: 2px;
                            font-weight: 600;
                            padding-left: 0px;
                            padding-right: 0px;
                            white-space: break-spaces;
                            background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), url('${require(`../../assets/${backColor(element)}`)}');
                            background-position: center;
                            background-size: 100% 100%;
                            border-radius: 0px;
                            height:15px;
                            min-height:38px;
                            
                        `"
                    >
                        <!-- <v-img v-if="element && element.basic" :src="require('../assets/Frame_empty.png')" :style="`position:absolute; z-index:2; pointer-events: none; height:100%; width:100%;`"></v-img>
                        <v-img v-if="element && element.basic" :src="require('../assets/Frame_empty.png')" :style="`position:absolute; z-index:2; pointer-events: none;bottom:0px;clip-path: inset(0px 0px 75% 0px); height:100%; width:100%;`"></v-img> -->
                        <span v-if="element && element.basic" :style="`width:100%;height:100%;background: radial-gradient(ellipse at center, rgba(128, 128, 128, 0) 60%, rgba(128, 128, 128, 0.5) 100%); background-blend-mode: overlay; position:absolute; z-index:2; pointer-events: none;`"></span>
                            <span :style="`
                                color: ${textColor(element)}; 
                                font-weight: bold; 
                                font-size: 16px;
                                text-align: center;
                                line-height: 16px;
                            `">
                                <v-img :src="require('../../assets/little_round_frame.png')" v-if="element.updated" style="position:absolute; align-items: center; height:30px; width:30px; top:-10px; right:-6px;" contain center>
                                    <v-img :src="require('../../assets/Mini_help green.png')" style="height:20px; filter: brightness(2);" contain></v-img>
                                </v-img>
                                {{ element.name }}
                            </span>
                        
                    </v-list-item>
                </draggable>
            </v-list>
        </v-col>
    </v-row>
    </v-col>
                                                                    <!-- Readied -->
    <v-row>
        <v-col cols="6" class="my-4">
        <h2>Readied</h2>
            <v-row class="my-4" :style="`min-height:300px;background-image:url('${require('../../assets/big_bar_bg.png')};background-position:center center; background-size:105% 100%;`">
                <v-col cols="3" v-for="n in 8" :key="n" style="min-height:200px; border-width:3px; border-style:ridge; background-color:transparent; border-color:grey;" class="pt-2">
                    <v-list style="background-color:transparent; height:100%" class="my-0 py-0">
                        <draggable :animation="200" style="height:100%"
                            :list="maneuverData.readiedManeuvers[n]"
                            :group="{ name: 'all', pull: true, put: true }"
                            item-key="id"
                            @add="(e)=>unbindReadied(e,n)"
                            >
                            <v-list-item 
                                outlined 
                                v-for="element in maneuverData.readiedManeuvers[n]" 
                                v-bind:key="element.name" 
                                @click="handleManeuverClick($event, element, maneuverData.readiedManeuvers[n], 'readied')" 
                                :style="`
                                    width: 100%; 
                                    border-color:${borderColor(element)};
                                    border-width: 2.5px; 
                                    border-style: ridge; 
                                    justify-content: center; 
                                    margin-bottom: 2px;
                                    font-weight: 600;
                                    padding-left: 0px;
                                    padding-right: 0px;
                                    white-space: break-spaces;
                                    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), url('${require(`../../assets/${backColor(element)}`)}');
                                    background-position: center;
                                    background-size: 100% 100%;
                                    border-radius: 0px;
                                    height:15px;
                                    min-height:38px;
                                `">
                                <span :style="`
                                    color: ${textColor(element)};
                                    font-weight: bold; 
                                    font-size: 16px;
                                    text-align: center;
                                    line-height: 16px;
                                `">
                                    {{ element.name }}
                                </span>
                            </v-list-item>
                        </draggable>
                    </v-list>
                </v-col>
            </v-row>
                                                                        <!-- Combo Bar -->
            <v-row>
                <div style="height:60px;width:100%;margin-top:0px;margin-bottom:0px;position:relative;z-index:1;top:-5px">
                <img :src="require('../../assets/combo_bar.png')" style=" height:100%;width:100%;-webkit-user-drag: none;">
                <img :src="require('../../assets/basic_bar2.png')" style="width:120px;position:absolute; z-index:1;color:white;top:3px;left:4px">
                <v-row style="position:absolute; z-index:1;top:47px;left:22px;">
                    <v-btn :ripple="false" small style="background-color:antiquewhite;min-width:4px;width:4px;padding-left:9px;padding-right:9px;max-height:18px;font-size:18px;border-radius:2px" @click="maneuverData.combo = []">C</v-btn>
                    <v-btn :ripple="false" small style="background-color:antiquewhite;min-width:4px;width:4px;padding-left:9px;padding-right:9px;max-height:18px;font-size:32px;border-radius:2px; margin-left:4px;padding-bottom:2px" @click="maneuverData.combo.splice(maneuverData.combo.length-1,1)">-</v-btn>
                </v-row>
                <span style="position:absolute; z-index:1;color:white;top:2px;left:20px;color:antiquewhite;font-size:20px;">COMBO:</span>
                <span style="position:absolute; z-index:1;color:white;top:34px;left:54px;color:antiquewhite;font-size:14px;text-align: right;min-width: 50%;" v-if="maneuverData.combo.length > 0">
                    <span v-for="(comboPoint, index) in maneuverData.combo" v-bind:key="(comboPoint,index)">
                    <v-tooltip bottom style="margin-right:4px;" open-delay="750">
                    <template v-slot:activator="{ on, attrs }">                      
                        <span v-bind="attrs" v-on="on" @click="maneuverData.combo.splice(index,1)" style="cursor:pointer"><span :style="`background-color:${comboColor(comboPoint)};font-weight:500;color: ${comboTextColor(comboPoint)}; padding-right:3px;padding-left:3px;border-radius:2px`">{{comboPoint}}</span><span v-if="maneuverData.combo[index+1]"> -> </span></span>
                    </template>
                    <span style="width:200px">{{comboPoint}} Mastery: {{maneuverInfo.find(tag=>tag.name == comboPoint).mastery}}
                        <br/><span v-if="focused.school=='elementalFlux'"><br/>Elemental Flux Mastery: {{maneuverInfo.find(tag=>tag.name == 'elementalFlux').mastery}}<br/>Combined: {{maneuverInfo.find(tag=>tag.name == 'elementalFlux').mastery + maneuverInfo.find(tag=>tag.name == comboPoint).mastery}}</span>
                        <span v-if="focused.school=='solarWind'"><br/>Solar Wind Mastery: {{maneuverInfo.find(tag=>tag.name == 'solarWind').mastery}}<br/>Combined: {{maneuverInfo.find(tag=>tag.name == 'solarWind').mastery + maneuverInfo.find(tag=>tag.name == comboPoint).mastery}}</span>
                        <br/>Click To Remove Combo Point</span>
                    </v-tooltip>
                    </span>
                    | &#x2190; Recent
                </span>
                
                <span style="position:absolute; color:white; z-index:2;top:5px;left:130px; max-height:60px;" v-if="focused && focused.name">
                    <v-row no-gutters>
                        <v-col v-for="tag in getComboTags(focused)" v-bind:key="tag">
                        <v-btn outlined block small @click="maneuverData.combo.push(tag)" :style="`background-color:${comboColor(tag)};color:${comboTextColor(tag)}; height:24px;margin-top:1px`">
                            {{tag}} 
                        </v-btn>
                    </v-col>
                    </v-row>
                </span>
                                                                    <!-- Recovery Button -->
                <v-row>
                    <v-divider></v-divider>
                    <v-btn small style="background-color:antiquewhite;max-width:160px;margin-right:20px;margin-top:-49px;height:28px" @click="maneuverDoc = true">Maneuver Mastery</v-btn>
                    <v-menu nudge-bottom="30" :close-on-content-click="false" transition="slide-y-transition" class="hiddenMenu">
                        <template v-slot:activator="{ props, on }">
                        <v-btn small style="background-color:antiquewhite;max-width:160px;margin-right:20px;margin-top:-49px;height:28px" v-bind="props" v-on="on">Maneuver Recovery</v-btn>                  
                        </template>
                        <span style="height:100%;overflow:hidden">
                        <v-img :src="require('../../assets/vertical_mid_frame.png')" :style="`position:absolute; z-index:2; pointer-events: none;`"></v-img>
                        <v-img :src="require('../../assets/vertical_mid_frame.png')" :style="`position:absolute; z-index:2; pointer-events: none;bottom:0px`"></v-img>
                        <v-card :style="`background-image:url('${require('../../assets/big_bar_bg.png')};background-position:center;`">
                        <div style="background-color:transparent;width:100%; padding-top:12px;margin-bottom:0px;min-height:16px;color:wheat!important; justify-content: space-around;display:flex; margin-right:0px;margin-left:0px">                        
                        <span>E: {{maneuverData.totalExpendedManeuvers}}</span> 
                        <span>||</span> 
                        <span>R: {{maneuverData.totalReadiedManeuvers}}</span>
                        </div>
                        <v-list dense style="background-color:transparent;margin-top:0px;padding-top:0px">                      
                            <v-list-item style="background-color:transparent;width:100%">                        
                            <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="recoverAll()">Recover All</v-btn>
                            </v-list-item >
                            <v-list-item style="background-color:transparent;width:100%">
                            <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="recoverRandom()">Recover Random</v-btn>
                            </v-list-item>
                            <v-list-item style="background-color:transparent;width:100%">
                            <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="expendAll()">Expend All</v-btn>
                            </v-list-item>
                            <v-list-item style="background-color:transparent;width:100%">
                            <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="expendRandom()">Expend Random</v-btn>
                            </v-list-item>
                            <v-list-item style="background-color:transparent;width:100%">
                                <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="unlockRandom()">Unlock Random</v-btn>
                            </v-list-item>
                            <v-list-item style="background-color:transparent;width:100%">
                                <v-btn small style="background-color:antiquewhite;height:30px;width:100%" @click="lockAll()">Lock All</v-btn>
                            </v-list-item>
                            </v-list>
                        </v-card>
                        </span>
                    </v-menu>
                </v-row>
                

            </div>
            <v-card elevation="0" class="light firefoxScroll mt-2" :style="`top:-9px;overflow-y: auto; background-color:rgb(0,0,0,0); width:100%; height:100%;`">
                <picker-card
                    class="mr-1 pt-2"
                    :characterSheetOverride="true"
                    :style="`min-height:300px; border-width:6px; border-style:ridge; border-color:${borderColor(focused)}!important; height:100%;`"
                    :item="focused"
                ></picker-card>
            </v-card>
            </v-row>
        </v-col>
        
                                                                    <!-- Specials -->
        <v-col cols="6" class="my-4">
            <h2>Specials</h2>
            <v-card :style="`background-image:url('${require('../../assets/big_bar_bg.png')};background-position:center center; background-size:105% 105%; width:100%;`">
                <v-row v-for="type in ['encounter','daily']" :key="type" :id="type" class="my-4 mx-0 pa-2" style="border-width:3px; border-style:ridge; border-color:grey; justify-content: center;">
                    <v-img :src="require('../../assets/name_frame_mid_ready.png')" height="48px" :style="`text-align:center;`" contain>
                        <h2 :style="`color:antiquewhite; padding-top:6px;`">{{ capitalize(type) }}</h2>
                        <div style="position:absolute; right:24px; top:4px; width:10px;"><v-icon @click="resetManeuvers(type)" style="color:antiquewhite;">mdi-refresh</v-icon></div>
                    </v-img>
                    <v-col :cols="colSize[index]" v-for="(subType, index) in maneuverData.specials[type].typeList" :key="subType">
                        <v-card width="100%" dense style="background-color:transparent; border-style:ridge; border-color:grey;">
                            <v-card-title class="py-3" style="justify-content:center;">                                
                                <span style="color:antiquewhite">{{ capitalize(subType) }}</span>
                                <span style="font-size:12px; display:flex; align-items:center; position:absolute; right:0px;">
                                    <v-btn x-small @click="increaseSingle(type,subType)" style="background-color:antiquewhite;color:black;margin-right:4px;">+</v-btn>
                                    <v-btn x-small @click="decreaseSingle(type,subType)" style="background-color:antiquewhite;color:black;margin-right:4px;">-</v-btn>
                                </span>
                            </v-card-title>

                            <v-list :key="maneuverData.specials[type][subType + 'Id']" style="background-color:transparent" class="pt-0 pb-0 mb-0">
                                <draggable :list="maneuverData.specials[type][subType]" :group="{ name: 'all', put:false, pull:false}" style="display:flex" :sort="false">
                                    <v-card @click="handleManeuverClick($event, maneuver, maneuverData.specials[type][subType], subType)" v-for="(maneuver, index2) in maneuverData.specials[type][subType]" v-bind:key="maneuver.id" :style="`width: 100%; min-height:75px; margin-top:0px!important; margin-bottom:0px!important;
                                        border-width: 2.5px; 
                                        border-style: ridge; 
                                        border-color:${borderColor(maneuver)};
                                        justify-content: center; 
                                        margin-bottom: 2px;
                                        font-weight: 600;
                                        padding-left: 0px;
                                        padding-right: 0px;
                                        white-space: break-spaces;
                                        background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), url('${require(`../../assets/${backColor(maneuver)}`)}');
                                        background-position: center;
                                        background-size: 100% 100%;
                                        border-radius: 0px;`" class="ma-4">
                                            <v-card-title :id="createSpecialId(type,subType, index2)" :style="`justify-content:center;height:100%; 
                                            color: ${textColor(maneuver)}; 
                                            font-weight: bold; 
                                            font-size: 16px;
                                            word-break: break-word;
                                            text-align: center;
                                        `">{{ maneuver.name }}
                                        </v-card-title>
                                    </v-card>
                                </draggable>
                            </v-list>
                            
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>


    <v-dialog v-model="disciplineHelpDoc">
          <v-card style="overflow: hidden; background-color:antiquewhite; height:80vh">
          <v-card-title class="headline brown darken-4 white--text">Discipline Info </v-card-title>
          <v-card-text style="color:black; overflow-y:hidden; height:97%;" class="px-0">
            <discipline-info style="height:100%; overflow-y:auto; padding-bottom:30px" class="light px-2"/>
          </v-card-text>        
      </v-card>
    </v-dialog>

    <v-dialog v-model="maneuverDoc" :content-class="`${isMozilla ? 'firefoxScroll' : 'darkBar2'} nooverflow`">
          <v-card style="overflow: hidden; background-color:transparent;width:100%;min-height: 70vh;">
          <v-img :style="`background-image:url('${require('../../assets/Inventory_bar 2.png')};background-repeat: round;min-height: 70vh;`">
          <v-card-title class="headline brown darken-4" :style="`width: 100%; overflow:hidden; color:antiquewhite;justify-content: center;font-size:42px!important`" hide-details="auto"><v-spacer/><v-spacer/>Maneuver Info<v-spacer/>
            <v-select style="width:300px;max-width:300px;background-color:antiquewhite;" class="noBottom" hide-details="true"
                v-model="comboSortBy" :items="['Alphabetic','Mastery']" dense solo-filled outlined></v-select>
          </v-card-title>          
            <v-row no-gutters style="overflow-x:hidden;justify-content:center;overflow-y:scroll;max-height:80vh; padding-left:16px;padding-bottom:32px" class="darkBar2">
              <v-col v-for="tag in maneuverInfo.filter(tag=>tag.count > 0)" v-bind:key="tag.id" class="py-2 mx-4 my-2" sm="2">
                <v-card :style="`background-image:url('${require('../../assets/big_bar_bg.png')};background-position:center;color:white; overflow:hidden; height:100%;max-height:475px; width:100%; box-shadow: ${comboColor(tag.name)} 0 0 25px${additionalComboColor(tag.name)};`">
                  <v-img eager :src="require('../../assets/vertical_mid_frame.png')" :style="`position:absolute; bottom:0px;width:100%;  pointer-events: none;`" cover></v-img>
                  <v-img eager :src="require('../../assets/vertical_mid_frame.png')" :style="`position:absolute; clip-path: inset(0px 0px 75% 0px);width:100%;  pointer-events: none;`" cover></v-img>
                  <v-card-title :style="`padding-top:24px;justify-content:center; color: ${comboColor(tag.name)}; text-shadow: ${comboShadowColor(tag.name)} 0 0 30px;font-size:32px`">{{capitalize(tag.name)}}</v-card-title>                  
                  <v-divider color="antiquewhite"></v-divider>
                  <v-card-subtitle class="py-2" style="color:antiquewhite">
                    <v-row>
                      <v-col style="text-align:center">
                    Total Known: <br/>{{tag.count}} 
                      </v-col>
                      <v-col style="text-align:center">
                        Levels Known: <br/>{{tag.levels.filter(level=> level.count > 0).length}}
                      </v-col>
                    </v-row>
                    <v-row style="justify-content:center; font-size:22px;margin-bottom:6px">
                      Mastery: {{tag.mastery}}
                    </v-row>
                  </v-card-subtitle>
                  <v-divider color="antiquewhite"></v-divider>
                  <v-card-text style="color:antiquewhite">
                    <div style="text-align:center; margin-bottom:12px">
                    Types Known:
                    </div>
                    <v-row style="margin-bottom:24px;text-align:center">
                      <v-col v-for="key in Object.keys(tag.types)" v-bind:key="key" style="white-space:nowrap;padding-bottom:0px;text-align:center">{{key}}s: {{tag.types[key]}}</v-col>
                    </v-row>
                    <v-divider style="margin-top:4px;margin-bottom:8px" color="antiquewhite"></v-divider>
                    <div style="text-align:center; margin-bottom:12px">
                      Levels Known:
                    </div>
                    <v-row no-gutters style="text-align: center;max-width:360px;margin-bottom:6px">
                        <v-col v-for="level in tag.levels.filter(level=>level.count > 0)" :key="level.level" cols="6" class="my-1">
                        level {{level.level}}: <span :style="`padding-right:6px;padding-left:6px;border-width: 0px 0px 2px 0px;;border-style: ridge;border-color: antiquewhite`"> {{level.count}} </span>
                        </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>           
            </v-img>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmUnlockDialog" max-width="400" @keydown.enter="confirmUnlock">
        <v-card style="background-color:antiquewhite">
            <v-card-title class="headline">Confirm Unlock</v-card-title>
            <v-card-text>
                You have this maneuver readied, which means you can't unlock it by normal rules. Are you sure you want to unlock it?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="confirmUnlockDialog = false">No</v-btn>
                <v-btn color="red darken-1" text @click="confirmUnlock">Yes</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


    <v-dialog v-model="websiteRulesDoc" max-width="800">
        <v-card style="background-color:antiquewhite">
            <v-card-title class="headline">Website Details</v-card-title>
            <v-card-text style="color:black">
                <b>Hotkeys:</b>
                <ul>
                    <li>Ctrl + Click on a maneuver to remove it from a list</li>
                    <li>Shift + Click on a maneuver to recover/expend it.
                        <ul>
                            <li>If a maneuver is locked, you will be asked to confirm unlocking it first.</li>
                            <li>If you have copies in your readied section, it will expend all of them.</li>
                        </ul>
                    </li>
                    <li>Alt + Click on a maneuver to lock/unlock it. If it is in the readied section, it will lock/unlock all copies.</li>
                    <li>Shift + Ctrl + Click on a maneuver in known to make it a practiced maneuver.</li>
                </ul>
                <br/>
                <b>General Instructions:</b>
                <ul>
                    <li>Add maneuvers from "Enter Maneuver Name to Learn" bar at the top. Is not case sensitive, you can click enter or the button to add them. this adds them to know.</li>
                    <li>Drag maneuvers from known to readied, or to your specials area. dragging a maneuver to readied locks it in the known section.</li>
                    <li>Click a maneuver to see more info in the bottom section, including its combo tags.</li>
                    <li></li>
                </ul>
                <br/>
                <b>Combo Tags:</b>
                    <ul>
                        <li><b>Add To Combo:</b> Click the combo tags in the top section to add it to your active combo. It is tracked from right to left, fromt he recent marker.</li>
                        <li><b>Mastery:</b> Hover combo points in the bar to see your mastery for that tag, or click maneuver mastery to the top right of the bar to see your mastery for all tags.</li>
                        <li><b>Combo Bar Controls:</b> Press C to clear all, - to remove the last tag, or click on the specific combo point to remove it.</li>
                    </ul>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="rulesDialog" max-width="800">
        <v-card style="background-color:antiquewhite">
            <v-card-title class="headline">Rules</v-card-title>
            <v-card-text style="color:black">
                <br/><b>Practiced:</b> Maneuvers that you have practiced, but not properly learned. You cannot ready these maneuvers, but you can add them to your encounter or daily lists.
                <br/><br/><b>Known:</b> All maneuvers you know and properly learned.
                <br/><br/><b>Core Maneuver:</b> Maneuvers that you have known, but not readied. You can use a core maneuver once per day. You can see whether a maneuver is know by whether or not it is locked.
                <br/><br/><b>Readied:</b> Maneuvers that you have readied.
                <br/><br/><b>Encounter:</b>
                <ul>
                    <li>Mastered: Prepared. Can be a readied maneuver. Use once per encounter. No Repeats.</li>
                    <li>Utility: Prepared. Cannot be a readied maneuver. Use once per encounter. No Repeats.</li>
                    <li>Flowing: Not Prepared. Can be a readied maneuver. No Repeats.</li>
                </ul>
                <br/><b>Daily:</b>
                <ul>
                    <li>Favorite: Prepared. Can be readied maneuver. Use once per day. Yes Repeats.</li>
                    <li>Perfected: Prepared. Can be a readied boost or counter. Use once per day. Does not use an action to initiate. No Repeats.</li>
                    <li>Flowing: Not Prepared. Can be a readied maneuver. No Repeats.</li>
                </ul>
                <br/><b>Mastery:</b>
                <ul>
                    You get 1 mastery per level of all known maneuvers, doubled on the first maneuver of that tag per level (max 9). <br/><br/>Finishers do not contribute to mastery. <br/><br/>Practiced maneuvers only contribute half, and cannot be doubled.
                </ul>
            </v-card-text>
        </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import disciplineInfo from '../../play/disciplineInfo'
import {maneuvers as maneuverDB} from "../../play/daba/maneuvers"
import draggable from 'vuedraggable';
import pickerCard from "../../play/PickerCard.vue"
import { comboTags, comboTagText} from '../../play/constants'
export default {
  components: {
    draggable,
    pickerCard,
    disciplineInfo,
  },
  props: {
    character: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
        maneuverData: this.character.maneuverTracker,
        maneuverDB: maneuverDB,
        rulesDialog:false,
        colSize:[12,6,6],
        comboSortBy:"Alphabetic",
        maneuverDoc:false,
        disciplineHelpDoc:false,
        websiteRulesDoc:false,
        comboTagText:[...comboTagText,"Ego", "Unique"],
        comboTags:{...comboTags,revelations:["Ego"],azureWind:["Air","Sakura","Guardian"],unique:["Unique"]},
        tempManeuver:{},
        focused:{},
        searchManeuver:"",
        confirmUnlockDialog: false,
        maneuverToUnlock: null,

    };
  },
  mounted(){
    window.addEventListener('contextmenu', function(ev) {
        ev.preventDefault();
        return false;
    }, false);
    
  },
  computed: {
    totalExpendedManeuvers() {
        // Get all maneuvers from all levels
        const allManeuvers = Object.values(this.maneuverData.readiedManeuvers).flat();
        
        // Create a Set of unique maneuver names that are expended
        const uniqueExpendedNames = new Set(
            allManeuvers
                .filter(maneuver => maneuver.expended)
                .map(maneuver => maneuver.name)
        );
        
        return uniqueExpendedNames.size;
    },
    totalReadiedManeuvers() {
        // Get all maneuvers from all levels
        const allManeuvers = Object.values(this.maneuverData.readiedManeuvers).flat();
        
        // Create a Set of unique maneuver names that are readied (not expended)
        // and aren't Stances or Finishers
        const uniqueReadiedNames = new Set(
            allManeuvers
                .filter(maneuver => 
                    !maneuver.expended && 
                    maneuver.type !== "Stance" && 
                    maneuver.type !== "Finisher"
                )
                .map(maneuver => maneuver.name)
        );
        
        return uniqueReadiedNames.size;
    },
    maneuverInfo(){
      //comboTagsWithExtra
      let tagInfo = []
      let obj = {count:0,types:{Strike:0,Boost:0,Counter:0,Stance:0},levels:[],id:Math.random(),mastery:0}
      for(let x = 0; x < 10; x++){
        obj.levels[x] = {level:x,count:0}
      }
      obj = JSON.stringify(obj)

      this.comboTagText.concat(['elementalFlux','solarWind']).forEach(comboTag=>{
        let tempObj = JSON.parse(obj)
        tempObj.name = comboTag
        tempObj.id = Math.random()
        tagInfo.push(tempObj)
      })
      let allManeuvers = Object.values(this.maneuverData.knownManeuvers).reduce((acc, levelArray) => acc.concat(levelArray), []);

      allManeuvers.forEach(maneuver=>{
        if(maneuver.type != "Finisher"){
          let tags
          if(maneuver.school == "solarWind") tags = [maneuver.school]
          else if(maneuver.school == "elementalFlux") tags = ["elementalFlux","Arcane"]
          else tags = this.comboTags[maneuver.school]
          if(maneuver.additionalTags) tags = tags.concat(maneuver.additionalTags)
          tags.forEach(tag=>{
            let db = tagInfo.find(tagDb=> tagDb.name == tag)
            db.count += 1
            db.types[maneuver.type] += 1
            let mastery = parseInt(maneuver.level)
            if(db.levels[maneuver.level].count == 0 && maneuver.basic == false) mastery *= 2
            if(mastery > 9) mastery = 9
            if(tag == "elementalFlux" || maneuver.basic) mastery = Math.ceil(mastery/2)
            db.mastery += mastery
            db.levels[maneuver.level].count += 1

          })
        }
      })
      if(this.comboSortBy != "Alphabetic"){
        tagInfo = tagInfo.sort(function(a, b){return b.mastery-a.mastery})
      }
      return tagInfo
    },
    isMozilla(){
      return navigator.userAgent.search("Firefox") > 1
    },
    },

    methods:{
        createSpecialId(type,subType, index){
            return type + ","+ subType + "," + index
        },
        addManeuver() {
            if(this.searchManeuver.includes("|")){
                const maneuverNames = this.searchManeuver.split('|').map(name => name.trim()).filter(name => name.length > 0);
                console.log('Mass adding maneuvers:', maneuverNames);
                maneuverNames.forEach(name=>{
                    this.searchManeuver = name
                    this.addManeuver(name)
                })
                return
            }
            const newManeuver = this.maneuverDB.find(m => 
                m.name.toLowerCase().trim() === this.searchManeuver.toLowerCase().trim()
            );
            if (newManeuver) {
                if(this.maneuverData.knownManeuvers[newManeuver.level].find(maneuver=>maneuver.name == newManeuver.name)) {
                    this.searchManeuver = "You Already Have This Maneuver!"; 
                    return;
                }
                // Create a copy of the maneuver to avoid reference issues
                let maneuverCopy = JSON.parse(JSON.stringify(newManeuver));
                maneuverCopy.id = Math.random(); // Add unique ID
                maneuverCopy.uiType = "maneuver"
                maneuverCopy.expended = false
                maneuverCopy.locked = false
                maneuverCopy.basic = false
                if(maneuverCopy.gameDesc) maneuverCopy.longDesc = maneuverCopy.gameDesc
                this.maneuverData.knownManeuvers[maneuverCopy.level].push(maneuverCopy);
                this.searchManeuver = ""; // Clear the search field
                //this.setFocus(maneuverCopy); // Optionally focus the new maneuver
            }else{
                this.searchManeuver = "Couldn't Find Maneuver";
            }
        },

        handleManeuverClick(event, maneuver, list, listName) {
            if(event.ctrlKey && event.shiftKey && listName == "known"){
                maneuver.basic = !maneuver.basic
                maneuver.locked = false
                maneuver.expended = false
                let readied = []
                this.getReadiedCopies(maneuver, (modify,level)=>{readied.push({modify,level})})
                readied.forEach(readiedManeuver=>{
                    let index = this.maneuverData.readiedManeuvers[readiedManeuver.level].findIndex(m=>m.id == readiedManeuver.modify.id)
                    this.maneuverData.readiedManeuvers[readiedManeuver.level].splice(index,1)
                })
            } else if (event.shiftKey && (!maneuver.basic || listName != "known")) {
                if(maneuver.locked) {
                    this.maneuverToUnlock = maneuver;
                    this.confirmUnlockDialog = true;
                } else {
                    if(listName == "readied"){
                        this.getReadiedCopies(maneuver, (modify)=>{modify.expended = !modify.expended})
                    }else{
                        maneuver.expended = !maneuver.expended;
                    }
                }
            } else if(event.ctrlKey) {
                let index = list.findIndex(listManeuver=>listManeuver.id == maneuver.id)
                if(listName != "readied" && listName != "known"){
                    list.splice(index, 1, {id:Math.random(),name:"Empty " + this.capitalize(listName) + "!"})
                }else{
                    list.splice(index, 1)
                }
                if(listName == "readied"){
                    let stillReadied = false
                    for (let level = 1; level <= 8; level++) {
                        for (let i = 0; i < this.maneuverData.readiedManeuvers[level].length; i++) {
                            let m = this.maneuverData.readiedManeuvers[level][i];
                            if (m.name === maneuver.name) {
                                stillReadied = true;
                                break;
                            }
                        }
                    }
                    if(!stillReadied) this.maneuverData.knownManeuvers[maneuver.level].find(m=>m.name == maneuver.name).locked = false
                }
            } else if(event.altKey && !maneuver.basic) {
                if(listName === "readied") {
                    this.getReadiedCopies(maneuver, (modify)=>{modify.locked = !modify.locked})
                }else{
                    maneuver.locked = !maneuver.locked
                }
            } else {
                this.focused = maneuver;
                maneuver.updated = false
            }
        },

        getReadiedCopies(maneuver, modify){
            for (let level = 1; level <= 8; level++) {
                this.maneuverData.readiedManeuvers[level].forEach(m => {
                    if (m.name === maneuver.name) {
                        modify(m,level)
                    }
                });
            }
        },

        unbindReadied(event, n) {
            const { newIndex } = event;
            let maneuver = this.maneuverData.readiedManeuvers[n][newIndex]
            if(this.maneuverData.readiedManeuvers[n].filter(foundManeuvers=>foundManeuvers.id == maneuver.id).length > 1 || maneuver.basic){
                this.maneuverData.readiedManeuvers[n].splice(newIndex,1)
                return
            }
            this.maneuverData.readiedManeuvers[n] = this.maneuverData.readiedManeuvers[n].map(item => ({...item}))
            this.maneuverData.readiedManeuvers[n][newIndex].locked = false
            this.maneuverData.knownManeuvers[maneuver.level].find(m=>m.name == maneuver.name).locked = true
        },
        increaseSingle(list,type){
            this.maneuverData.specials[list][type].push({id:Math.random(),name:"Empty " + this.capitalize(type) + "!"})
        },
        decreaseSingle(list,type){
            this.maneuverData.specials[list][type].splice(this.maneuverData.specials[list][type].length-1,1)
        },

        tempGrab(e,n){
            this.tempManeuver = this.maneuverData.knownManeuvers[n][e.oldIndex]
        },
        
        ended(e){
            //let hoveredElement = document.elementFromPoint(e.originalEvent.clientX, e.originalEvent.clientY)
            let hoveredElementID = document.elementFromPoint(e.originalEvent.clientX, e.originalEvent.clientY).id
            //console.log(hoveredElement, hoveredElementID, e.originalEvent.clientX, e.originalEvent.clientY)
            if(hoveredElementID){
                let idArr = hoveredElementID.split(",")
                if(idArr.length == 3){
                    this.tempManeuver = JSON.parse(JSON.stringify(this.tempManeuver))
                    this.tempManeuver.locked = false
                    this.tempManeuver.basic = false
                    this.tempManeuver.id = Math.random()
                    this.maneuverData.specials[idArr[0]][idArr[1]].splice(idArr[2],1, this.tempManeuver)
                    this.maneuverData.specials[idArr[0]][idArr[1] + "Id"] = Math.random()
                }
            }
            this.tempManeuver = {}
            // let div = document.createElement("div")
            // div.style.position = "absolute"
            // div.style.left = e.originalEvent.pageX + "px"
            // div.style.top = e.originalEvent.pageY + "px"
            // div.style.width = "30px"
            // div.style.height = "30px"
            // div.textContent = this.x++
            // div.style.backgroundColor = "red"
            // document.body.appendChild(div)
        },
        recoverAll(){
            this.getAllReadiedManeuvers().forEach(maneuver=>{maneuver.expended = false})
        },

        expendAll(){
            this.getAllReadiedManeuvers().forEach(maneuver=>{
                if(maneuver.type != "Stance" && maneuver.type != "Finisher" && !(maneuver.subSchool && maneuver.subSchool[0] == "sterlingTactic")) maneuver.expended = true
            })
        },

        recoverRandom(){
            let expended = this.getAllReadiedManeuvers().filter(maneuver=> (maneuver.expended==true || (maneuver.subSchool && maneuver.subSchool[0] == "sterlingTactic")) && maneuver.type != "Finisher" && maneuver.locked == false)
            if(expended.length > 0){
                let chosen = expended[Math.floor(Math.random()*expended.length)]
                if(chosen.subSchool && chosen.subSchool[0] == "sterlingTactic") chosen.stacksOne += 1
                else{
                    this.getReadiedCopies(chosen, (modify)=>{modify.expended = false})
                }
                this.focused = chosen
            }
        },
        expendRandom(){
            let ready = this.getAllReadiedManeuvers().filter(maneuver=> maneuver.expended==false && maneuver.type != "Stance" && maneuver.type != "Finisher" && maneuver.locked == false)
            if(ready.length > 0){
                let chosen = ready[Math.floor(Math.random()*ready.length)]
                this.getReadiedCopies(chosen, (modify)=>{modify.expended = true})
                this.focused = chosen
            }
        },
        getAllReadiedManeuvers(){
            let readied = []
            Object.keys(this.maneuverData.readiedManeuvers).forEach(key=>{
                this.maneuverData.readiedManeuvers[key].forEach(maneuver=>{
                    readied.push(maneuver)
                })
            })
            return readied
        },
        getAllKnownManeuvers(){
            let known = []
            Object.keys(this.maneuverData.knownManeuvers).forEach(key=>{
                this.maneuverData.knownManeuvers[key].forEach(maneuver=>{
                    known.push(maneuver)
                })
            })
            return known
        },
        unlockRandom(){
            let unlocked = this.getAllReadiedManeuvers().filter(maneuver=>maneuver.locked == true)
            if(unlocked.length > 0){
                let chosen = unlocked[Math.floor(Math.random()*unlocked.length)]
                this.getReadiedCopies(chosen, (modify)=>{modify.locked = false})
                this.focused = chosen
            }
        },
        lockAll(){
            this.getAllReadiedManeuvers().forEach(maneuver=>{
                maneuver.locked = true
            })
        },
        resetManeuvers(type){
            this.resetEncounter()
            if(type == "daily"){
                this.resetDaily()
            }
        },
        resetEncounter(){
            this.getAllReadiedManeuvers().forEach(maneuver=>{
                maneuver.expended = false
                if(maneuver.stacksOne) maneuver.stacksOne = 0
            })
            this.maneuverData.specials.encounter.mastered.forEach(maneuver=>{
                maneuver.expended = false
            })
            this.maneuverData.specials.encounter.utility.forEach(maneuver=>{
                maneuver.expended = false
            })
            this.maneuverData.specials.encounter.flowing.forEach(maneuver=>{
                maneuver.expended = false
            })
        },
        resetDaily(){
            this.getAllKnownManeuvers().forEach(maneuver=>{
                maneuver.expended = false
            })
            this.getAllReadiedManeuvers().forEach(maneuver=>{
                maneuver.expended = false
                if(maneuver.stacksOne) maneuver.stacksOne = 0
            })
            this.maneuverData.specials.daily.favorite.forEach(maneuver=>{
                maneuver.expended = false
            })
            this.maneuverData.specials.daily.perfected.forEach(maneuver=>{
                maneuver.expended = false
            })
            this.maneuverData.specials.daily.flowing.forEach(maneuver=>{
                maneuver.expended = false
            })
        },

        //////////////////////////////////////////////////////////// COLOR FUNCTIONS ////////////////////////////////////////////////////////////

        borderColor(item) {
            if (!item) return "rgb(40,39,40)";
            else if (item.updated) return "rgb(0,128,0)";
            else if (item.locked) return "rgb(144,144,144)";
            else if (item.expended) return "rgb(250, 5, 5)";
            else if (item.basic) return "rgb(128,128,128)";
            return "rgb(144,144,144)";
        },
        backColor(item) {
            let color = "";
            if (item.type == "Strike") color = "red";
            else if (item.type == "Boost") color = "gold";
            else if (item.type == "Finisher") color = "light_blue";
            else if (item.type == "Counter") color = "purple";
            else if (item.type == "Stance") color = "white";
            else color = "white";
            return "Background_" + color + ".png";
        },
        textColor(item) {
            let color = "#FFFFFF";
            if (item.updated) return "lawngreen"
            if (item.type == "Stance") color = "#000000";
            if (item.basic) color = "rgb(144,144,144)";
            if (item.expended) color = "#ff0000";
            if (item.locked) color = "rgb(144,144,144)";
            return color;
        },
        comboColor(tag) {
            let colorArr = {
                Air: "rgba(192, 230, 245, 255)",
                Arcane: "rgba(12, 118, 158, 255)",
                Curse: "rgba(81, 21, 74, 255)",
                Power: "rgba(0,100,0,255)",
                Dark: "rgba(0, 0, 0, 255)",
                Death: "rgba(14, 0, 33, 1)",
                Earth: "rgba(153, 125, 55, 255)",
                Fire: "rgba(255, 110, 1, 255)",
                Flurry: "rgba(192, 0, 0, 255)",
                Guardian: "rgba(190, 80, 20, 255)",
                Heroic: "rgba(255, 255, 0, 255)",
                Light: "rgba(255, 255, 153, 255)",
                Primal: "rgba(192, 0, 0, 255)",
                Royal: "rgba(120, 33, 112, 255)",
                Sakura: "rgba(242, 206, 239, 255)",
                Shadow: "rgba(128, 128, 128, 255)",
                Technique: "rgba(71, 211, 89, 255)",
                Void: "rgba(216, 109, 205, 255)",
                Water: "rgba(68, 179, 225, 255)",
                elementalFlux: "rgba(163, 89, 83, 255)",
                solarWind: "rgba(245, 179, 66, 255)",
                Ego: "rgba(120, 81, 169, 255)",
                Unique: "rgb(156, 38, 148)",
            };
            return colorArr[tag] || "#000000";
        },

        comboShadowColor(tag) {
            if (tag == "Death") return "rgba(255,255,255,1)";
            else if (tag == "Dark") return "rgba(14, 0, 33, 1)";
            else return this.comboColor(tag);
        },

        additionalComboColor(tag) {
            if (tag == "Dark") return ",rgba(0, 0, 0, 10) 0px 0px 25px,rgba(0, 0, 0, 10) 0px 0px 100px";
            else if (tag == "Death") return ",rgb(14, 0, 33) 0px 0px 25px,rgb(14, 0, 33) 0px 0px 25px,rgb(14, 0, 33) 0px 0px 25px";
            else return "";
        },

        comboTextColor(tag) {
            let whiteArr = ["Dark", "Death", "Royal", "Curse", "Flurry"];
            return whiteArr.includes(tag) ? "#FFFFFF" : "#000000";
        },

        getComboTags(maneuver) {
            let tags = []
            if(maneuver.additionalTags) tags = maneuver.additionalTags
            if(maneuver.type != "Stance" && maneuver.type != "Finisher") tags = tags.concat(this.comboTags[maneuver.school])
            return tags
        },

        addCombo(tag){
            if(this.maneuverData.combo.length == 7){
                this.maneuverData.combo.splice(0,1)
            }
            this.maneuverData.combo.push(tag)
        },

        capitalize(str) {
            for (let x = 0; x < str.length; x++) {
                if (str[x].toUpperCase() == str[x]) {
                    str = str.substring(0, x) + " " + str.substring(x, str.length);
                    break;
                }
            }
            let newStr = str[0].toUpperCase() + str.substring(1);
            return newStr;
        },

        confirmUnlock() {
            if (this.maneuverToUnlock) {
                this.maneuverToUnlock.locked = false
                this.getReadiedCopies(this.maneuverToUnlock, (modify)=>{modify.locked = false})
                this.maneuverToUnlock = null;
                this.confirmUnlockDialog = false;
            }
        },
    },
    watch:{
        'saveStatus.id':{
            handler : function(){
                setTimeout(()=>{
                    this.saveStatus.show = false
                }, 12 * 1000)
            },
            deep:true
        },
        'character.maneuverTracker': {
            handler: function(newVal) {
                this.maneuverData = newVal;
            },
            deep: true
        }
    }
}
</script>

<style>
.hiddenMenu, .v-menu__content {
  overflow-y: hidden!important;
  margin-left:12px;
}
.text-antiquewhite input {
      color: antiquewhite !important;
}
.draggable-notes {
  will-change: transform;
  cursor: move;
  box-shadow: 0 4px 8px rgba(0,0,0,0.2);
}
.no-background.v-icon.v-icon::after {
  background-color: transparent;
}
.background_bar{
    background: url('../../assets/basic_bar_elonged.png');
    background-size: 105% 76px;
    background-repeat:no-repeat;
    background-position-y: center;
    background-position-x: center;
}
</style>
